import React from 'react';
import { ReverseRotate } from '../reverse-rotate';
import { round } from '../..';
import { BaseLabel } from '../base-label';
export var Label = function (_a) {
    var _b = _a.x, x = _b === void 0 ? 0 : _b, _c = _a.y, y = _c === void 0 ? 0 : _c, width = _a.width, height = _a.height, children = _a.children, _d = _a.angle, angle = _d === void 0 ? 0 : _d, color = _a.color;
    var midX = round(width / 2);
    var midY = round(height / 2);
    // Save DOM nodes whenever possible - this very common component
    return (React.createElement("svg", { x: x, y: y, width: width, height: height },
        React.createElement(ReverseRotate, { rotateX: midX, rotateY: midY, angle: angle },
            React.createElement(BaseLabel, { color: color }, children))));
};
//# sourceMappingURL=label.js.map